import React from "react";

const CloneIcon = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill={color}
    >
      <path
        d="M1.42857 1.42857H12.8571V4.28571H14.2857V1.42857C14.2857 1.04969 14.1352 0.686328 13.8673 0.418419C13.5994 0.15051 13.236 0 12.8571 0H1.42857C1.04969 0 0.686328 0.15051 0.418419 0.418419C0.15051 0.686328 0 1.04969 0 1.42857V12.8571C0 13.236 0.15051 13.5994 0.418419 13.8673C0.686328 14.1352 1.04969 14.2857 1.42857 14.2857H4.28571V12.8571H1.42857V1.42857Z"
        fill="#0073C8"
      />
      <path
        d="M18.571 5.71436H7.14244C6.76356 5.71436 6.4002 5.86487 6.13229 6.13277C5.86438 6.40068 5.71387 6.76405 5.71387 7.14293V18.5715C5.71387 18.9504 5.86438 19.3137 6.13229 19.5817C6.4002 19.8496 6.76356 20.0001 7.14244 20.0001H18.571C18.9499 20.0001 19.3133 19.8496 19.5812 19.5817C19.8491 19.3137 19.9996 18.9504 19.9996 18.5715V7.14293C19.9996 6.76405 19.8491 6.40068 19.5812 6.13277C19.3133 5.86487 18.9499 5.71436 18.571 5.71436ZM18.571 18.5715H7.14244V7.14293H18.571V18.5715Z"
        fill="#0073C8"
      />
      <path
        d="M12.1427 17.1427H13.5713V13.5713H17.1427V12.1427H13.5713V8.57129H12.1427V12.1427H8.57129V13.5713H12.1427V17.1427Z"
        fill="#0073C8"
      />
    </svg>
  );
};

export default CloneIcon;
